export function collectSceneTransferables(config) {
    const transferables = [];
    if (config.videoSlots) {
        for (const slot of config.videoSlots) {
            if (slot.imageBitmap) {
                transferables.push(slot.imageBitmap);
            }
        }
    }
    if (config.background?.type === 'image') {
        transferables.push(config.background.bitmap);
    }
    return transferables;
}
